import Vue from 'vue';
import _ from 'lodash';
import {
    GET_USER_DETAIL_REQUEST,
    GET_USER_DETAIL_SUCCESS,
    GET_USER_DETAIL_FAILURE,
    RESOLVE_USER_DETAIL_PARAMS,
    GET_USER_CAR_LIST_FAILURE,
    GET_USER_CAR_LIST_SUCCESS,
    GET_USER_CAR_LIST_REQUEST,
    RESOLVE_USER_CAR_LIST_PARAMS,
    UPDATE_CLIENT_DETAIL_PARAMS
} from '../mutationTypes';

const state = {
    loading: false,
    carsLoading: false,
    carListData: [],
    userDetailData: {},
    userId :'',
    mobile:'',
    page: 1,
    pageSize: 10,
    pageCount: 1,
    userDetailReqParams: {},
    carListReqParams:{}
};

const mutations = {
    // 请求开始(用户详情)
    [GET_USER_DETAIL_REQUEST](state) {
        state.loading = true;
    },
    // 请求成功(用户详情)
    [GET_USER_DETAIL_SUCCESS](state, res) {
        state.loading = false;
        state.userDetailData = res;
    },
    // 请求失败(用户详情)
    [GET_USER_DETAIL_FAILURE](state) {
        state.loading = false;
        state.userDetailData = {};
    },
    // 更新请求参数
    [UPDATE_CLIENT_DETAIL_PARAMS](state, params) {
        const {
            userId, mobile, page
        } = params;
        if (userId || userId === '') state.userId = userId;
        if (mobile || mobile === '') state.mobile = mobile;
        if (page) {
            state.page = page; // 分页要进行请求
        }
    },
    [RESOLVE_USER_DETAIL_PARAMS](state, reqParams) {
        state.userDetailReqParams = reqParams;
    },
    // 请求开始(车辆列表)
    [GET_USER_CAR_LIST_REQUEST](state) {
        state.carsLoading = true;
    },
    // 请求成功(车辆列表)
    [GET_USER_CAR_LIST_SUCCESS](state, res) {
        state.carsLoading = false;
        state.pageCount = res.page_count;
        state.carListData = res.car_list;
    },
    // 请求失败(车辆列表)
    [GET_USER_CAR_LIST_FAILURE](state) {
        state.carsLoading = false;
        state.pageCount = 1;
        state.carListData = [];
    },
    [RESOLVE_USER_CAR_LIST_PARAMS](state, reqParams) {
        state.carListReqParams = reqParams;
    },
};

export const actions = {
    async getClientUserDetail({ commit }) {
        commit(GET_USER_DETAIL_REQUEST);

        const res = await Vue.$ajax.get('userInfo', state.userDetailReqParams);

        if (!res.errorType) {
            commit(GET_USER_DETAIL_SUCCESS, res);
        } else {
            commit(GET_USER_DETAIL_FAILURE);
        }
    },
    resolveClientUserDetailParams({ commit }) {
        const params = {};
        params.user_id = state.userId;
        commit(RESOLVE_USER_DETAIL_PARAMS, params);
    },
    async getUserCarList({ commit }) {
        commit(GET_USER_CAR_LIST_REQUEST);

        const res = await Vue.$ajax.get('carList', state.carListReqParams);

        if (!res.errorType) {
            commit(GET_USER_CAR_LIST_SUCCESS, res);
        } else {
            commit(GET_USER_CAR_LIST_FAILURE);
        }
    },
    resolveUserCarListParams({ commit }) {
        const params = _.pick(state, ['page', 'mobile']);
        // params.user_id = state.userId;
        params.page_size = state.pageSize;
        commit(RESOLVE_USER_CAR_LIST_PARAMS, params);
    },
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/clientDetail.js